import { Route } from 'vue-router';
import { Next } from '@cnamts/vue-dot/src/types';

import { MAINTENANCE_ENABLED } from '@/constants';

/**
 * Main navigation redirection logic
 *
 * @param {Route} to Vue Router to param
 * @param {Route} from Vue Router from param
 * @param {Route} next Vue Router next param
 * @returns {void}
 */
export function navigationRedirect(to: Route, from: Route, next: Next): void {
	if (MAINTENANCE_ENABLED) {
		// Avoid infinite loop
		if ('maintenance' !== to.name) {
			next({ name: 'maintenance' });
		} else {
			next();
		}
	} else if ('maintenance' === to.name) {
		next({ name: 'search' });
	} else {
		next();
	}
}
